import getOptionValue from '../userPreferences/getOptionValue';
export default function isDebugging() {
    return getOptionValue(21) === 'true';
}
